import React from 'react'

const PayerChart = () => {
    return (
        <>
            <div className="col-md-3">
                <div className="update-bx">
                    <h3>Payer Time</h3>
                    <div className="p-3">
                        <h4>
                            Fajr <span>06.30 PM</span>
                        </h4>
                        <h4>
                            Johor <span>01.30 PM</span>
                        </h4>
                    </div>
                    <span className="close-btn d-none">
                        <i className="fa fa-times-circle-o" />
                    </span>
                </div>
            </div>
        </>
    )
}

export default PayerChart